import { Options, Vue } from 'vue-class-component'
import { VueCookieNext } from 'vue-cookie-next'
import { host } from '@/api/Conf';
import Header from '@/components/Header.vue'
@Options({
  components: {
    Header
  }
})
export default class TransitDetail extends Vue {
  Invoices: any = [];
  IsLoading: any = false;
  UniqueCode: any = '';
  ArriveDate: any = '';
  tac = false;
  Diffs: any = []

  public openEdit(): void {
    document.querySelector<HTMLElement>('.modal-transit-detail').style.display = 'block'
  }
  public closeEdit(): void {
    document.querySelector<HTMLElement>('.modal-transit-detail').style.display = 'none'
  }
  public async submit() : Promise<void> {
    let answer;
    if(this.Diffs.every((d: number)=> d === 0)){
      answer = confirm('Apakah anda yakin data yang akan di submit sudah sesuai dan tidak selisih?');
    } else {
      answer = confirm('Apakah anda yakin data selisih yang Anda input sudah benar?');
    }
    if (answer) {
      this.IsLoading = true;
      try {
        const Diffs = `<Diffs>${this.Invoices.filter((d: number) => d !== 0).map((d: any)=> { return `<Item InvoiceDetailID="${d.InvoiceDetailID}" Qty="${d.Difference}" Remarks="${d.Remarks}"/>`}).join('')}</Diffs>`
        // console.log(`Exec USP_AR_Invoices_VerifyAndUpdateArrivalDate @InvoiceID=${this.$route.params.id}, @ArriveDate='${this.ArriveDate.replace('T', ' ')}:00',@UniqueCode='${this.UniqueCode}',@Differences='${Diffs}'`)
        await this.axios.post(`${host}/api/v1/query`, {
          "q": `Exec USP_AR_Invoices_VerifyAndUpdateArrivalDate @InvoiceID=${this.$route.params.id}, @ArriveDate='${this.ArriveDate.replace('T', ' ')}:00',@UniqueCode='${this.UniqueCode}',@Differences='${Diffs}'`,
          "plain": false
        });
        alert('Data submitted successfully');
        window.location.href = '/transit';
      }catch (e) {
        alert(e);
      } finally {
        this.IsLoading = false;
      }
    }
  }
  public async mounted(): Promise<void> {
    if(!VueCookieNext.getCookie('CustID')){
      window.location.href = '/login'
    }else{
      this.IsLoading = true;
      const response = await this.axios.post(`${host}/api/v1/query`, {
        "q": `Exec USP_AR_Invoices_Query 1, ${this.$route.params.id}`,
        "plain": false
      });
      const items = response.data;
      this.Invoices = items.filter( (d: any)=> Object.keys(d).join(',') !== 'Type,Name' && Object.keys(d).includes('InvoiceDetailID') );
      this.IsLoading = false;
      this.Invoices = this.Invoices.map((d: any)=> {
         d.Difference = 0;
         return d;
      })
    }
  }
}